import React, { useCallback, useContext } from "react";
import { useAppDispatch } from "../../../../state/store";
import { updateNotificationEmailAction } from "../../../../state/usecase/user/actions";
import { NotificationEmailContext } from "../../../provider/NotificationEmailProvider";
import { Button } from "../../common/button/Button";

export const SaveButtonArea = React.memo(function SaveButtonArea() {
    const { notificationEmailList } = useContext(NotificationEmailContext);

    const dispatch = useAppDispatch();

    const isNotificationEmailListUpdateButtonActive = notificationEmailList.every(email => email.value);

    const handleNotificationEmailListUpdateClicked = useCallback(() => {
        // フォーマットチェック
        const invalidMessage: string[] = [];

        notificationEmailList.forEach((notification, index) => {
            if (!notification.isValid()) invalidMessage.push(`メールアドレス${index + 1}の形式が正しくありません。`);
        });

        if (invalidMessage.length) {
            alert(invalidMessage.join("\n"));
            return;
        }

        dispatch(updateNotificationEmailAction(notificationEmailList));
    }, [dispatch, notificationEmailList]);

    return (
        <div className={"button_area"}>
            <Button
                label={"変更内容を反映する"}
                disabled={!isNotificationEmailListUpdateButtonActive}
                onClick={handleNotificationEmailListUpdateClicked}
            />
        </div>
    );
});
